import React, {useContext, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import SelectTitle from "../../../../components/radioGroup/SelectTitle";
import RadioGroup from "../../../../components/radioGroup/RadioGroup";
import {FormControl, Grid, InputLabel, MenuItem, OutlinedInput} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import {WMSContext} from "../../context/WMSContext";
import {blueColor, greyishBlue200} from "../../../../assets/jss/main";
import {FormattedMessage} from "react-intl";
import Select from '@mui/material/Select';
import UncheckedCheckBox from 'assets/img/wms/uncheckedCheckBox.svg';
import CheckedCheckBox from 'assets/img/wms/checkedCheckedBox.svg'

RunnerSelect.propTypes = {
    runners: PropTypes.object.isRequired,
    selectedRunners: PropTypes.array.isRequired,
    handleSelectRunners: PropTypes.func.isRequired,
    desktopMaxWidth: PropTypes.string
};

function RunnerSelect({runners, selectedRunners, handleSelectRunners, desktopMaxWidth}) {
    const {isMobile} = useContext(WMSContext)

    //The commented code is for the multi version of the select.
    // It is not used yet because the WmsTask might have an issue in handling multiple associated Members
    // const [selectedRunnersName, setSelectedRunnersName] = useState([]);
    const [selectedRunnersName, setSelectedRunnersName] = useState("");
    const [formattedRunners, setFormattedRunners] = useState();

    useEffect(() => {
        let tempData = []

        // selectedRunners.map((runner) => {
        //     tempData.push(runner["name"])
        // })
        // setSelectedRunnersName(tempData)

        setSelectedRunnersName(selectedRunners["name"])
    }, [selectedRunners]);

    useEffect(() => {
        const dataKeys = Object.keys(runners)
        let tempData = []
        dataKeys.map((k) => {
            tempData.push(runners[k])
        })

        setFormattedRunners(tempData)
    }, [runners])
    return (
        <Grid container direction={"column"} gap={"32px"}>
            <span
                style={{fontSize:"20px", color: blueColor, fontWeight: 600}}
            >
                <FormattedMessage id={"wms.newPickingMission.selectRunner.title"}/>
            </span>
            <Grid container direction={"column"} sx={{width:"100%", maxWidth: isMobile ? 'none' : desktopMaxWidth ?? "30%"}}>
                <SelectTitle required={true} titleTranslationKey={"wms.newPickingMission.members"} />
                <FormControl>
                    <Select
                        variant={"filled"}
                        // multiple
                        value={selectedRunners}
                        input={<OutlinedInput/>}
                        // renderValue={() => selectedRunnersName.join(', ')}
                        renderValue={() => selectedRunnersName}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "top",
                                horizontal: "left",
                            },
                            transformOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                            },
                            PaperProps: {
                                sx: {
                                    border: "1px solid",
                                    borderColor: greyishBlue200,
                                    borderRadius: "8px",
                                    boxShadow: "none",
                                },
                                style: {
                                    transform: "translateY(-8px)",
                                },
                            },
                        }}
                    >
                        {formattedRunners && formattedRunners.map((runner) => (
                            <MenuItem
                                onClick={() => handleSelectRunners(runner)}
                                sx={{paddingX: "16px"}}
                            >
                                <Grid
                                    container
                                    direction={'row'}
                                    flexWrap={'nowrap'}
                                    justifyContent={"space-between"}
                                    alignContent={"center"}
                                >
                                    <span style={{height: "fit-content", margin: "auto 0"}}>{runner.name}</span>
                                    <Checkbox checked={runner.selected} icon={<img src={UncheckedCheckBox}/>} checkedIcon={<img src={CheckedCheckBox}/>}/>
                                </Grid>

                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>

    );
}

export default RunnerSelect;
